<template>
  <div class="account-actions-panel">
    <div class="container">
      <change-password />
      <logout />
    </div>
  </div>
</template>

<script>
import Logout from '@/components/common/Logout.vue';
import ChangePassword from '@/components/common/ChangePassword.vue';

export default {
  components: {
    Logout,
    ChangePassword,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables';
@import '~@/assets/styles/colors';
@import '~@/assets/styles/breakpoints';

.account-actions-panel {
  height: $bar-height;
  box-shadow: 0 0 $shadow-size $shadow;
  display: flex;
  width: 100%;
}

.container {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: $container-padding;
}

@media (max-width: $header-breakpoint) {
  .account-actions-panel {
    display: none;
  }
}
</style>
